import React,{useState,useEffect}from "react";
import { Modal,Button,Input,TreeSelect,Row,Col, Form, Space,Switch,Select } from "antd";
import "./style.css";
import CreateJDModal from "./createJDModal";
import PdfLogo from "../../assets/pdf-logo.svg";
import Api from "services/Api";
import { useWindowDimensions } from "components/layout";
import ViewPDF from "./ViewPdf";
const JdActionModal = (props) =>{
    const [showUpdateModal,setUpdateModal]=useState(false);
    const {width}=useWindowDimensions();
    const [arrays,setArr]=useState([])
    const [viewPdfModal,setViewPdfModal] = useState(false);
    const [resumePdf,setResumePdf] = useState(null);
  

    let arr=[]
    useEffect(() =>{
     arr =props.record.jobInterviewrounds.map((element) =>{
      return element
     })  
     setArr(arr.sort((a, b)=>{return parseInt(a.round) - parseInt(b.round)}))  
    },[])
    const toggleUpdateModal = (record) => {        
        setUpdateModal(!showUpdateModal);
      };
    let data=[]
Object.keys(props.record).forEach(keys =>{    
        let item=keys
        if(item==="noticePeriod" || item==="keywords" || item==="location" || item==="agencies"){
      data.push({
            keys:item,
            value:props.record[keys]
        })}
    })
   
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
      setIsModalVisible(true);
    };
  
    const handleOk = () => {
      setIsModalVisible(false);
    };
  
    const handleCancel = () => {
      setIsModalVisible(false);
    };
    const getFileName = (fileName) => {
        return fileName.split('/').at(-1);
      }
  return(<>
    {width>700?<Button style={{color:"black",borderColor:"#00FF61",backgroundColor:"#EAFFF2",width:"6rem",fontWeight:"bold",fontSize:"0.8rem",height:"1.7rem"}} onClick={showModal}>
  VIEW
  </Button>:
  <button onClick={showModal} style={{color:"#fff",background:"#1089FF",outline:"none",border:0,height:"2.3rem",borderRadius:"0.4rem"}}>View</button>
  }
  <Modal style={{ top: 15 }} centered title={props.record.title} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={false} >
  {/* <Row justify="end"><Switch size="large" defaultChecked={props.record.status==="Active"} checkedChildren="Active" unCheckedChildren="Inactive"  onChange={(e) =>{
  let statusvalue
     if(e)
     {
        statusvalue="Active"
       
     }
     else{
        statusvalue="Inactive"
     }
     Api.patch(`/hiring-job/jdStatus/${props.record.key}?status=${statusvalue}`).params({})
     .send((resp) =>{
        props.refresh()
     })
     }} /></Row> */}
  <div className="college-modal-scroll" style={{marginBottom:"10px"}}>
  <div>
<Row>
    <Col span={12}>
<div style={{ textAlign: "center" }}>
  <img
    onClick={() => {
      setViewPdfModal(true);
      setResumePdf(props.record.descriptionFile);
    }}
    src={PdfLogo}
    alt="pdf-logo"
    style={{width:"50%"}}
  />
</div>
{width>700&&<div style={{ textAlign: "center" }}> <span >{getFileName(props.record.descriptionFile ?props.record.descriptionFile :"")}</span></div>}
</Col>
<Col span={12}>
    <Row><p className="college-modal-field">Organization department</p>
    <Input disabled value={props.record.jobType?.name}/></Row>
    <Row><p className="college-modal-field">number of openings</p>
    <Input disabled value={props.record.vacancies}/></Row>
    <Row><p className="college-modal-field">Priority</p>
    <Input disabled value={props.record.priority}/></Row>
    </Col></Row>

</div>
    <Row><p className="college-modal-field">Experience</p></Row>
   <Row> <Col style={{marginRight:"10px"}} span={width>700?"11":"10"}><Input disabled value={props.record.minExperience}/></Col>-{" "}<Col style={{marginLeft:"10px"}} span={width>700?"11":"10"}><Input disabled value={props.record.maxExperience}/></Col></Row>
   {data.map((item) =>{
    if(item.value===null)
    {
        return
    }
    else if(item.keys==="agencies" || item.keys==="keywords")
    {  let array
         if(item.keys==="agencies"){
          array=item.value.map((item) =>{
          return item.agencyName
    })}
    else{
        array=item.value
    }
        return (
        <>
        {props?.user?.role?.includes("Admin") || props?.user?.role?.includes("Super-Admin") && item.keys === "agencies" ? 
        <>
         <div className="college-modal-field">{item.keys}</div>
        <Select value={array}  disabled mode="multiple"/>
        </>
        : item.keys === "keywords" ?
        <>
         <div className="college-modal-field">{item.keys}</div>
        <Select value={array}  disabled mode="multiple" style={{width:"100%"}}/>
        </>
        :
        ""
        }
      </>
      )  
    }
    return(
        <><div className="college-modal-field">{item.keys}</div>
        <Input  value={item.value} disabled/>
      
        </>
    )
   })}
     {arrays.map((item) =>{
            return(<>
                <p className="college-modal-field">Round:{item.round}</p>
                <Input disabled value={item.roundType === "Relationship" ? "HR Relationship" : item.roundType}/>
            </>)
        })}
        <Row justify="center" style={{marginTop:"1rem"}}>
         
          {props?.user?.role.includes("Recruiter") || props?.user?.role.includes("Sourcer") || props?.user?.role.includes('Panelist') || props?.user?.role.includes('Shortlister')?
            // <Button onClick={handleCancel}>Cancel</Button>
            ""
           :
           <Space>
              <Button onClick={handleCancel}>Cancel</Button>
             <Button type="primary" onClick={() =>{
              setIsModalVisible(false);
              setUpdateModal(true)}}
              >EDIT</Button>
           </Space>
          }
        </Row>
  </div>
 </Modal>
  
  {showUpdateModal && <CreateJDModal 
            shortlister={props.shortlister}
            selectedObject={props.record}
            poc={props.poc}
            roundAgency={props.roundAgency}
            orgType={props.orgType}
            jobLocations={props.jobLocations}
            isOpen={showUpdateModal}
            setIsModalVisible={setIsModalVisible}
            refresh={props?.refresh}
            toggle={toggleUpdateModal.bind(this)}/>
  }
  {viewPdfModal && <ViewPDF viewPdfModal={viewPdfModal} setViewPdfModal={setViewPdfModal} resumePdf={resumePdf} setResumePdf={setResumePdf} />}
</>
  )
}
export default JdActionModal